export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./WizardProvider.vue?vue&type=template&id=33163dbc&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/WizardProvider.vue?vue&type=template&id=33163dbc&scoped=true
// module id = 2501
// module chunks = 31